import {Component, Input, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InternalService} from '../../services/internal.service';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'modal-profile',
  templateUrl: './profileModal.component.html',
  styleUrls: ['./profileModal.component.css']
})
export class ProfileModalComponent implements OnInit {

  Message: any;
  userProfile: any = [];
  isShow = false;

  constructor(
    public internalService: InternalService,
    public apiService: ApiService,
    private router: Router,
    public matDialog: MatDialog,
    private ngbModal: NgbModal,
    public dialogRef: MatDialogRef<ProfileModalComponent>,
  ) {
  }

  ngOnInit() {
    this.getUserProfile(this.internalService.userId);

  }
  // idCardInfo:
  //   image: ""
  // number: "2360296396"

  getUserProfile(id) {
    this.apiService.apiCall('get', '/api/Account/ShowProfileInAdminPanel/' + id, {})
      .subscribe((response: any) => {
           console.log(response);
        this.userProfile = response.res;
        if(this.userProfile.idCardInfo.image){
          this.internalService.getMd5(this.userProfile.idCardInfo.image).then(result=>{
            this.userProfile.idCardInfo.imageIdCard=result;
          });
        }
        if(this.userProfile.profilePic){
          this.internalService.getMd5(this.userProfile.profilePic).then(result=>{
             this.userProfile.profilePicture=result;
          });
        }
        if(this.userProfile.technicnianInfo.idCard){
          this.internalService.getMd5(this.userProfile.technicnianInfo.idCard.image).then(result => {
            this.userProfile.technicnianInfo.idCard.image = result;
          })
        }
        if(this.userProfile.technicnianInfo.licenses){
          for (let img of this.userProfile.technicnianInfo.licenses){
            this.internalService.getMd5(img.imageMD5).then(result => {
              img.imageMD5 = result;
            })
          }
          
        }
      });
  }
  sendMessage(userId) {
    const body = {
      text: this.Message,
      userId: userId
    };
    this.apiService.apiCall('post', '/api/Admin/SendMessage/', body).subscribe((response: any) => {
      // console.log(response);
      if (response.stu === 1) {
        this.apiService.showMessage('Message.YourMessageHasBeenSend', response.stu);
      }
    });
    this.Message = '';
  }
  showImage(data) {
    const image = new Image();
    image.src = data;
    setTimeout(()=>{
      const w = window.open('');
      w.document.write(image.outerHTML);
    }, 500);
  }

  navigateToChat() {
    this.matDialog.closeAll();
    // this.ngbModal.dismissAll();
    this.router.navigate(['/manager/messages/'+this.internalService.userId]);

  }
}
